import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'components/consumer/Link';
import IconBell from 'components/icons/iconBell';
import IconMail from 'components/icons/iconMail';
import useUserData from 'data-hooks/useUserData';
import { colorGrayLight3 } from 'styles/layout/colors';
const MobileNavbarFooter = () => {
  const $ = _c(7);
  const {
    isTradeUser
  } = useUserData();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-lg font-bold">Need a Hand?</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isTradeUser) {
    t1 = <p className="text-sm text-gray flex flex-col content-center">{isTradeUser ? <><span className="flex flex-col content-center mb-3" aria-label="Trade user hours of business"><span>Mon-Fri: 7:00 am - 4:00 pm PST</span><span>Sat-Sun: Closed</span></span><span className="flex flex-col content-center" aria-label="Trade user telephone number"><span>Call Us:{" "}<a className="text-brand" href="tel:+18552084414">(855) 208-4414</a></span></span></> : <><span className="flex flex-col content-center mb-3" aria-label="Hours of business"><span>Mon-Fri: 6:00 am - 5:00 pm PST</span><span>Sat-Sun: 8:00 am - 4:00 pm PST</span></span><span className="flex flex-col content-center" aria-label="Telephone numbers"><span>Call Us:{" "}<a className="text-brand" href="tel:+18882820842">(888) 282-0842</a></span></span></>}</p>;
    $[1] = isTradeUser;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link className="text-sm font-bold text-gray rounded-[3px] flex flex-col items-center px-2 py-4 text-center hover:underline" to="https://help.joybird.com"><div><IconBell color={colorGrayLight3} /></div>FAQ</Link>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-row justify-evenly mx-auto mt-4 max-w-[400px]">{t2}<Link className="text-sm font-bold text-gray rounded-[3px] flex flex-col items-center px-2 py-4 text-center hover:underline-link" to="https://joybird.com/contact-us/"><div><IconMail color={colorGrayLight3} /></div>Contact Us</Link></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1) {
    t4 = <div className="text-center">{t0}{t1}{t3}</div>;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default MobileNavbarFooter;